import FormSelect, { FormSelectProps, SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { JobStatuses } from 'store/jobs/job';
import { JOB_STATUS_COLOR_MAP } from 'store/jobs/utils';

const STATUSES_TO_DISPLAY: JobStatuses[] = [
    JobStatuses.NEW,
    JobStatuses.IN_PROGRESS,
    JobStatuses.AWAITING_PAYMENT,
    JobStatuses.COMPLETED,
    JobStatuses.OVERDUE,
    JobStatuses.PARTIALLY_PAID,
];

const jobsStatusOptions: SelectOption[] = Object.entries(JOB_STATUS_COLOR_MAP)
    .filter(([status]) => STATUSES_TO_DISPLAY.includes(status as JobStatuses))
    .map(([status, config]) => ({
        id: status as JobStatuses,
        value: config.label,
    }));

type JobSelectProps = Omit<FormSelectProps, 'selectOptions'> & {};

const JobStatusSelect = (props: JobSelectProps) => {
    return (
        <FormSelect
            hideKeys
            selectOptions={jobsStatusOptions}
            renderOptionContent={(item) => {
                const status = item.id as JobStatuses;
                const color = JOB_STATUS_COLOR_MAP[status].color;
                const text = JOB_STATUS_COLOR_MAP[status].label;

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span
                            style={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }}
                        />
                        <span>{text}</span>
                    </div>
                );
            }}
            {...props}
        />
    );
};

export default JobStatusSelect;
